import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import iconFileDelete from "../../../assets/media/icon-file-delete.svg";
import iconSearch from "../../../assets/media/icon-search.svg";
import iconCaretLeft from "../../../assets/media/icon-caret-left.svg";
import iconCaretRight from "../../../assets/media/icon-caret-right.svg";
import iconCaretDown from "../../../assets/media/icon-caret-down.svg";
import Avatar01 from "../../../assets/media/avatar-01.png";

import Navbar from "../../navbar";
import Header from "../../header";

import { useDispatch, useSelector } from "react-redux";
import { addEmployee } from "../../../store/reducers/employeeSlice.js";
import { fetchEmployee } from "../../../store/reducers/employeeSlice.js";
import { fetchFeedbacks } from "../../../store/reducers/feedbackSlice";
import Pagination from "../dashboard/appPagination";
import Modal from "../../modal/Modal";
import classes from "./style.module.css";
import { fetchCompanies } from "../../../store/reducers/companiesSlice.js";
import userImagePlaceholder from "../../../assets/media/avatar2.png";
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
} from "@tanstack/react-table";

const AppFeedback = () => {
  const dispatch = useDispatch();
  const feedbacks = useSelector((state) => state.feedbacks.data);
  const companies = useSelector((state) => state.companies.companies);
  const fetchLoading = useSelector((state) => state.employee.fetchLoading);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredFeedbacks, setFilteredFeedbacks] = useState([]);
  const [filteredByCompany, setFilteredByCompany] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({});
  const user = useSelector((state) => state.auth.user);
  const [selectedCompanyId, setSelectedCompanyId] = useState("");

  useEffect(() => {
    dispatch(fetchFeedbacks({ accessToken: user.access_token }));
    dispatch(fetchCompanies({ accessToken: user.access_token }));
  }, [dispatch, user]);

  useEffect(() => {
    filterByCompany(selectedCompanyId); // Apply company filter initially
  }, [feedbacks, selectedCompanyId]);

  useEffect(() => {
    const filteredData = feedbacks
      .filter((item) =>
        Object.values(item).some((value) =>
          value && value.toString().toLowerCase().includes(searchTerm.toLowerCase())
        )
      )
      .sort((a, b) => b.id - a.id);
    setFilteredFeedbacks(filteredData);
  }, [searchTerm, feedbacks]);

  const handleInputChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const filterByCompany = (companyId) => {
    if (companyId) {
      const filteredData = Array.isArray(feedbacks) ? feedbacks.filter(
        (item) => item.company_id === companyId
      ) : [];
      setFilteredByCompany(filteredData);
    } else {
      setFilteredByCompany(Array.isArray(feedbacks) ? feedbacks : []);
    }
  };

  // State to store the selected company_id
  const handleCompanyFilter = (companyId) => {
    setSelectedCompanyId(companyId);
    filterByCompany(companyId);
  };

  const getTotalPages = () => {
    if (Number.isInteger(filteredFeedbacks?.length / 10))
      return filteredFeedbacks?.length / 10;
    return Math.floor(filteredFeedbacks?.length / 10) + 1;
  };

  const show = (filteredFeedbacks) => {
    console.log({ filteredFeedbacks });
    setModalContent(filteredFeedbacks);
    setShowModal(true);
  };
  const close = () => {
    setModalContent({});
    setShowModal(false);
  };

  // Define table columns
  const columns = useMemo(
    () => [
      {
        header: "S.NO.",
        cell: (info) => info.row.index + 1,
      },
      {
        header: "Employee Id",
        accessorKey: "id",
        cell: (info) => `GB-000000${info.getValue()}`,
      },
      {
        header: "Name",
        accessorKey: "full_name",
        cell: (info) => {
          const item = info.row.original;
          return (
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <img
                src={item.image || userImagePlaceholder}
                alt="Avatar"
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: "50%",
                }}
              />
              <div>
                <strong>{item.full_name}</strong>
              </div>
            </div>
          );
        },
      },
      {
        header: "Subject",
        accessorKey: "subject",
        cell: (info) => <a>{info.getValue()}</a>,
      },
      {
        header: "Message",
        accessorKey: "message",
        cell: (info) => (
          <a>
            {info.getValue()?.length < 50
              ? info.getValue()
              : info.getValue().substring(0, 47) + "..."}
          </a>
        ),
      },
    ],
    [userImagePlaceholder]
  );

  const table = useReactTable({
    data: filteredFeedbacks,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <>
      <div>
        <Navbar />
        <Header />
        <div className="wrapper">
          <div className="boxAppBoard boxWhite">
            <div className="boardHeader noMg">
              <div className="boardHeadLeft">
                <h2>Feedbacks</h2>
              </div>
            </div>
          </div>

          <div className="boxAppBoard boxWhite mt-5">
            <div className="boardHeader">
              <div className="boardHeadLeft">
                <h2>All Feedbacks</h2>
              </div>
              <div className="boardHeadRight">
                <div className="searchForm">
                  <input
                    type="text"
                    placeholder="Search"
                    onChange={handleInputChange}
                    value={searchTerm}
                  />
                  <button>
                    <img src={iconSearch} alt="" />
                  </button>
                </div>
                <div className="datePicker"></div>
              </div>
            </div>

            {/* New Table Implementation */}
            <div className="boardContent">
              {fetchLoading ? (
                <div className="d-flex justify-content-center my-4">
                  <div
                    className="text-center items-center spinner-border text-primary"
                    style={{ width: "4rem", height: "4rem" }}
                    role="status"
                  ></div>
                </div>
              ) : (
                <>
                  {!!filteredFeedbacks?.length ? (
                    <table className="table">
                      <thead>
                        {table.getHeaderGroups().map((headerGroup) => (
                          <tr key={headerGroup.id}>
                            {headerGroup.headers.map((header) => (
                              <th key={header.id}>
                                {flexRender(
                                  header.column.columnDef.header,
                                  header.getContext()
                                )}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody>
                        {table.getRowModel().rows.map((row) => (
                          <tr
                            key={row.id}
                            onClick={() => show(row.original)}
                            style={{ cursor: 'pointer' }}
                          >
                            {row.getVisibleCells().map((cell) => (
                              <td key={cell.id}>
                                {flexRender(
                                  cell.column.columnDef.cell,
                                  cell.getContext()
                                )}
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <div className="text-center">
                      <h6 className="text-primary my-4 py-4">
                        Feedbacks not Found
                      </h6>
                    </div>
                  )}
                </>
              )}
            </div>

            <Pagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              totalPages={getTotalPages}
            />
          </div>
        </div>
      </div>
      <Modal show={showModal} handleClose={close} colWidth={6}>
        <div
          className={[
            classes["modal-content-row-1"],
            "d-flex",
            "align-items-center",
          ]}
        >
          <div
            className={[
              classes["modal-content-row-1"],
              "d-flex",
              "align-items-center",
              "justify-content-between",
            ].join(" ")}
          >
            <div className="d-flex align-items-center">
              <div className={classes["profile-pic-wrapper"]}>
                <img
                  alt="Avatar"
                  style={{ borderRadius: "50%", width: "70px", height: "70px" }}
                  src={modalContent.image || userImagePlaceholder}
                />
              </div>
              <div>
                <p className={classes["user-name"]}>{modalContent.full_name}</p>
                <p className={classes["user-company"]}>
                  {modalContent.company_name}
                </p>
              </div>
            </div>
          </div>
          <div className={[classes["modal-content-row-2"], "my-3"].join(" ")}>
            <p className={[classes["subject-content"], "mb-0"].join(" ")}>
              <strong>Subject:</strong>
              {modalContent.subject}
            </p>
          </div>
          <div className={[classes["modal-content-row-3"], "my-3"].join(" ")}>
            <p className={[classes["message-content"], "mb-0"].join(" ")}>
              {modalContent.message}
            </p>
          </div>
        </div>
      </Modal>
    </>
  );
};
export default AppFeedback;